import { render, staticRenderFns } from "./PartnerGradeList.vue?vue&type=template&id=5b3e4bfa&scoped=true"
import script from "./PartnerGradeList.vue?vue&type=script&lang=js"
export * from "./PartnerGradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e4bfa",
  null
  
)

export default component.exports